import ButtonLink from '../../../common/components/Button/ButtonLink.js'
import {showParentOrderModal} from '../Modals/ParentOrderModal.js'

export default function ParentOrder({orderNumber, parentOrderNumber}) {
  return (
    <>
      <div>
        <strong>Parent Order:</strong> <span>{parentOrderNumber}</span>
      </div>
      <ButtonLink onClick={() => showParentOrderModal(orderNumber)}>
        View details
      </ButtonLink>
    </>
  )
}
